import GroupsIcon from "@mui/icons-material/Groups";

import EmployeeInformationLight from "assets/images/sidebar/employee-roster-light.png";
import TimesheetLight from "assets/images/sidebar/timesheet-light.png";
import ConfigOptionLight from "assets/images/sidebar/config-option-light.png";

import EmployeeInformationDark from "assets/images/sidebar/employee-roster-dark.png";
import TimesheetDark from "assets/images/sidebar/timesheet-dark.png";
import rolelight from "assets/images/sidebar/role-light.png";
import roledark from "assets/images/sidebar/role-dark.png";
import taskdark from "assets/images/sidebar/task-dark.png";
import tasklight from "assets/images/sidebar/task-light.png";
import projectlight from "assets/images/sidebar/project-light.png";
import projectdark from "assets/images/sidebar/project-dark.png"
import learndark from 'assets/images/sidebar/local_library_FILL0_wght400_GRAD0_opsz24.svg'
import learnlight from 'assets/images/sidebar/local_library_FILL0_wght400_GRAD0_opsz24 2.svg'
import LeaveLight from "assets/images/sidebar/Leavelight.png"
import LeaveDark from "assets/images/sidebar/badge_FILL0_wght400_GRAD0_opsz24 1.png"
import EmployeeHandbookLight from "assets/images/sidebar/employee-handbook-light.svg"
import ReportLight from "assets/images/sidebar/report-light.svg"
import ReportDark from "assets/images/sidebar/report-dark.svg"
import trainings from "assets/images/sidebar/training.png"
import Performance from "assets/images/sidebar/Performance.svg"
import exit from "assets/images/sidebar/exit.svg"
import Attendance from "assets/images/sidebar/attendance.png";

var sideBarRoutes = [
  {
    name: "Employee Information",
    to: "/panel/EmployeeInformation",
    permissionName: "VIEW_EMPLOYEE",
    lightIcon: EmployeeInformationLight,
    darkIcon: EmployeeInformationDark,
  },

  {
    name: "Timesheet",
    to: "/panel/timesheetsummary",
    permissionName: "VIEW_TIMESHEET",
    icon: <GroupsIcon />,
    lightIcon: TimesheetLight,
    darkIcon: TimesheetDark,
  },

  {
    name: "Roles",
    to: "/panel/projectrole",
    permissionName: "VIEW_ROLE",
    lightIcon:rolelight,
    darkIcon:roledark,
  },


  {
    name: "Project Setup",
    to: "/panel/project",
    permissionName: "VIEW_PROJECT",
    lightIcon: projectlight,
    darkIcon: projectdark,
  },

  {
    name: "Task Setup",
    to: "/panel/projecttask",
    permissionName: "VIEW_TASK",
    lightIcon: taskdark,
    darkIcon: tasklight,
  },

  {
    name: "Config Option",
    to: "/panel/configurationPage",
    permissionName: "VIEW_CONFIG",
    lightIcon: ConfigOptionLight, 
    darkIcon: ConfigOptionLight,
  },

  {
    name: "Reports",
    to: "/panel/reports",
    permissionName: "VIEW_REPORT",
    lightIcon: ReportLight, 
    darkIcon: ReportDark,
  },

  {
    type: "TP",
    name: "Training Nexus",
    // to: "http://localhost:4000/hrms",
    to: "https://training-nexus.valuehealthsolutions.com/hrms",
    permissionName: "VIEW_TRAINING_NEXUS",
    lightIcon: learnlight, 
    darkIcon: learndark,

  },

    {
    name: "Leave Management",
    to: "/panel/leaveManagement",
    permissionName: "VIEW_LEAVE_MANAGEMENT",
    lightIcon: LeaveLight, 
    darkIcon: LeaveDark,
    subRoutes: [
      {
        name: "Manager View",
        to: "/panel/leaveManagement/managerView",
        permissionName: "VIEW_LEAVE_MANAGEMENT_MANAGER_VIEW",
      },
      {
        name: "My View",
        to: "/panel/leaveManagement",
        permissionName: "VIEW_LEAVE_MANAGEMENT_MANAGER_VIEW",
      },
      
    ],
  },
  {
    name: "Attendance",
    to: "/panel/attendance",
    permissionName: "VIEW_ATTENDANCE",
    lightIcon: taskdark, 
    darkIcon: taskdark,
    subRoutes: [
      {
        name: "Manager View",
        to: "/panel/attendance/ManagerView",
        permissionName: "VIEW_ATTENDANCE_MANAGER",
      },
      {
        name: "My View",
        to: "/panel/attendance",
        permissionName: "VIEW_ATTENDANCE_MANAGER",
      },
      
    ],
  },

// {
//   name: "Trainings",
//   to: "/panel/trainings",
//   permissionName: "VIEW_LEAVE_MANAGEMENT",
//   lightIcon: LeaveLight, 
//   darkIcon: trainings,
// },

{
  name: "RP Homepage",
  to: "/panel/rpHomePage",
  permissionName: "VIEW_RP_HOMEPAGE",
  lightIcon: LeaveLight, 
  darkIcon: LeaveDark,
},

  {
    type:"employee-handbook-document",
    name: "Employee Handbook",
    to: "static/EmployeeHandbook.pdf",
    permissionName: "VIEW_EMPLOYEE_HANDBOOK",
    lightIcon: EmployeeHandbookLight, 
    darkIcon: EmployeeHandbookLight,
  },

  // {
  //   name: "Performance",
  //   to: "/panel/performance",
  //   permissionName: "VIEW_LEAVE_MANAGEMENT",
  //   lightIcon: Performance, 
  //   darkIcon: Performance,
  // },

  {
    name: "Performance Management",
    to: "/panel/PerformanceManagement",
    permissionName: "APPRAISAL_MANAGEMENT_HR",
    lightIcon: Performance, 
    darkIcon: Performance,
    subRoutes: [
      {
        name: "HR View",
        to: "/panel/PerformanceManagement/HRview",
        permissionName: "APPRAISAL_MANAGEMENT_HR",
      },
      {
        name: "Manager View",
        to: "/panel/PerformanceManagement/ManagerView",
        permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      },
      {
        name: "My View",
        to: "/panel/PerformanceManagement",
        permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      },
      {
        name: "Reports",
        to: "/panel/PerformanceManagement/HRReport",
        permissionName: "APPRAISAL_MANAGEMENT_HR",
      },
      // {
      //   name: "My View",
      //   to: "/panel/PerformanceManagement/EmployeeView",
      //   permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      // },
     
      
    ],
  },
  {
    name: "Performance Management",
    to: "/panel/PerformanceManagement",
    permissionName: "VIEW_APPRAISAL_MANAGEMENT",
    lightIcon: Performance, 
    darkIcon: Performance,
    subRoutes: [
      {
        name: "Manager View",
        to: "/panel/PerformanceManagement/ManagerView",
        permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      },
      {
        name: "My View",
        to: "/panel/PerformanceManagement",
        permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      },
      {
        name: "Reports",
        to: "/panel/PerformanceManagement/ManagerReport",
        permissionName: "APPRAISAL_MANAGEMENT_MANAGER",
      },
    ],
  },
  {
    name: "Exit Management",
    to: "/panel/ExitManagement",
    permissionName: "VIEW_CLEARANCE_HR",
    lightIcon: exit, 
    darkIcon: exit,
    subRoutes: [
      {
        name: "Manager View",
        to: "/panel/ExitManagement_Manager",
        permissionName: "VIEW_CLEARANCE_HR",
      },
      {
        name: "HR View",
        to: "/panel/ExitManagementHR",
        permissionName: "VIEW_CLEARANCE_HR",
      },
    ],
  },
 
  {
    name: "Exit Management",
    to: "/panel/ExitManagementManager",
    permissionName: "VIEW_CLEARANCE_MANAGER",
    lightIcon: exit, 
    darkIcon: exit,
  },
  

  {
    name: "Exit Management",
    to: "/panel/ExitManagement",
    permissionName: "VIEW_CLEARANCE_IT",
    lightIcon: exit, 
    darkIcon: exit,
    subRoutes: [
    
      {
        name: "Manager View",
        to: "/panel/ExitManagementManager",
        permissionName: "VIEW_CLEARANCE_MANAGER_IT",
      },
      {
        name: "IT View",
        to: "/panel/ExitManagementIT",
        permissionName: "VIEW_CLEARANCE_IT",
      },
    ],
  },
  {
    name: "Exit Management",
    to: "/panel/ExitManagement",
    permissionName: "VIEW_CLEARANCE_FINANCE",
    lightIcon: exit, 
    darkIcon: exit,
    subRoutes: [
    
      {
        name: "Manager View",
        to: "/panel/ExitManagementManager",
        permissionName: "VIEW_CLEARANCE_MANAGER_FINANCE",
      },
      {
        name: "Finance View",
        to: "/panel/ExitManagementFinance",
    permissionName: "VIEW_CLEARANCE_FINANCE",
      },
    ],
  },
  {
    name: "Exit Management",
    to: "/panel/ExitManagement",
    permissionName: "VIEW_CLEARANCE_ADMIN",
    lightIcon: exit, 
    darkIcon: exit,
    subRoutes: [
    
      {
        name: "Manager View",
        to: "/panel/ExitManagementManager",
        permissionName: "VIEW_CLEARANCE_MANAGER_ADMIN",
      },
      {
        name: "Admin View",
        to: "/panel/ExitManagementAdmin",
        permissionName: "VIEW_CLEARANCE_ADMIN",
      },
    ],
  },
  
  {
    name: "Probation Management",
    to: "/panel/probation-management",
    permissionName: "VIEW_PROBATION_MANAGEMENT",
    icon: <GroupsIcon />,
    lightIcon: projectlight,
    darkIcon: projectdark,
  },

];

export default sideBarRoutes;
